import React from 'react';

import * as Store from '@apply/store';

import { EntryField } from './EntryField';

export interface SubdivisionProps {
    category:
        | Store.FormsStore.Types.BudgetCategory
        | Store.FormsStore.Types.LandBudgetCategory
        | Store.FormsStore.Types.FixFlipBudgetCategory
        | Store.FormsStore.Types.SpecSheetCategory;
    valueSpecs: Store.FormsStore.Types.ValueSpec[];
    values: Record<string, Store.FormsStore.Types.FormRecordValueType>;
    submitting: boolean;
    printMode?: boolean;
    onChange: (valueName: string, newvalue: Store.FormsStore.Types.FormRecordValueType) => void;
}

export const Subdivision: React.FC<SubdivisionProps> = ({ category, valueSpecs, values, submitting, onChange, printMode }) => {
    const backgroundColor = category.toString().includes('Subcontractor') ? '#808080' : '#2c5591';
    return (
        <div
            className={category + ' printable-section'}
            style={{ display: 'flex', flexDirection: 'column' }}
        >
            <div
                style={{
                    fontSize: 'larger',
                    width: '100%',
                    textAlign: 'left',
                    color: 'white',
                    backgroundColor,
                    padding: '5px',
                    paddingLeft: '10px',
                }}
            >
                {category}
            </div>
            {valueSpecs.map((spec, index) => {
                const handleChange = (newvalue: Store.FormsStore.Types.FormRecordValueType) => {
                    onChange && onChange(spec.name, newvalue);
                };
                const defaultValue: Store.FormsStore.Types.FormRecordValueType = [
                    'otherdescribe',
                    'amountwithdescription',
                ].includes(spec.datatype)
                    ? ['', '']
                    : '';
                const value = values[spec.name] !== undefined ? values[spec.name] : defaultValue;
                return (
                    <EntryField
                        onChange={handleChange}
                        value={value}
                        spec={spec}
                        category={category}
                        submitting={submitting}
                        key={`entry-field-${category}-${spec.name}-${index}`}
                        printMode={printMode}
                    />
                );
            })}
        </div>
    );
};
